import API from './Api';

const api = API.create();

export default api;